import { getHeaders } from './localStorage';
import axios from 'axios';
import { api, versao } from '../config';
import errorHandling from './errorHandling';
import { GET_REPORT_PAYMENT, GET_REPORT_PRODUCTS, CLEAR_REPORTS, GET_REPORT_RE_OFFER_ACTION, GET_REPORT_DASHBOARD, GET_REPORT_DELIVERIES_BY_BAIRRO_ENTREGADOR } from './types';

export const getDashboard = ({ initial, final }, loja, cb) => {
	return function(dispatch){
		axios.put(`${api}/${versao}/api/reports/dashboard?loja=${loja}`, { initial, final }, getHeaders())
		.then(response => {
			dispatch({ type: GET_REPORT_DASHBOARD, payload: response.data });
			cb();
		})
		.catch(errorHandling);
	};
};

export const getReportPayment = ({ initial, final }, loja, cb) => {
	return function(dispatch){
		axios.put(`${api}/${versao}/api/reports/payments?loja=${loja}`, { initial, final }, getHeaders())
		.then(response => {
			dispatch({ type: GET_REPORT_PAYMENT, payload: response.data });
			cb();
			console.log('res-->>',response.data);
		})
		.catch(errorHandling);
	};
};

export const getReportProducts = ({ initial, final, shippingPeriod }, loja, cb) => {
	return function(dispatch){
		const body = { initial, final };
		if (shippingPeriod) body.shippingPeriod = shippingPeriod;
		axios.put(`${api}/${versao}/api/reports/products?loja=${loja}`, body, getHeaders())
		.then(response => {
			dispatch({ type: GET_REPORT_PRODUCTS, payload: response.data });
			cb();
		})
		.catch(errorHandling);
	};
};

export const generatePdfProductsReport = ({ initial, final, shippingPeriod }, loja, cb) => {
	return function(){
		const body = { initial, final };
		if (shippingPeriod) body.shippingPeriod = shippingPeriod;
		axios.put(`${api}/${versao}/api/reports/products/pdf?loja=${loja}`, body, getHeaders())
		.then(response => {
			cb(response.data);
		})
		.catch(errorHandling);
	};
};

export const getReportDeliveriesByBairroEntregador = ({ initial, final }, loja, cb) => {
	return function(dispatch){
		axios.put(`${api}/${versao}/api/reports/deliveries-by-bairro-entregador?loja=${loja}`, { initial, final }, getHeaders())
		.then(response => {
			dispatch({ type: GET_REPORT_DELIVERIES_BY_BAIRRO_ENTREGADOR, payload: response.data });
			cb();
		})
		.catch(errorHandling);
	};
};

export const generatePdfDeliveriesByBairroEntregadorReport = ({ initial, final }, loja, cb) => {
	return function(){
		axios.put(`${api}/${versao}/api/reports/deliveries-by-bairro-entregador/pdf?loja=${loja}`, { initial, final }, getHeaders())
		.then(response => {
			cb(response.data);
		})
		.catch(errorHandling);
	};
};

export const getReportReOfferAction = ({ when }, loja, cb) => {
	return function(dispatch){
		axios.get(`${api}/${versao}/api/reports/reOffer?loja=${loja}&when=${when}`, getHeaders())
			.then(response => {
				console.log(response.data);
				dispatch({ type: GET_REPORT_RE_OFFER_ACTION, payload: response.data });
				cb();
				// console.log('res-->>',response.data.reOfferRows[0]);
			})
			.catch(errorHandling);
	};
};

export const clearReports = () => {
	return function(dispatch){
		dispatch({ type: CLEAR_REPORTS });
	};
};